export default __webpack_public_path__ + "static/media/cart.26595397.svg";